import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { ProductTopBanner } from "../components/ProductTopBanner";

export const ProductTimeline = () => {
  return (
    <>
      <PageTitle pageName={pageName.product.task} />
      <ProductTopBanner buttonType="back" />
    </>
  );
};
